import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// In production with custom domains, API should be on same origin
// Use current origin if BACKEND_URL points to a different domain
const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    // If backend URL is different from current origin, use current origin
    // This handles custom domains where both frontend and backend are on same domain
    if (BACKEND_URL && !BACKEND_URL.includes(window.location.hostname)) {
      return `${currentOrigin}/api`;
    }
  }
  return `${BACKEND_URL}/api`;
};
export const API = getApiUrl();

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id SYNCHRONOUSLY during render
  // This prevents race conditions - must happen before ProtectedRoute
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid #27272A',
            color: '#FAFAFA',
          },
        }}
      />
    </div>
  );
}

export default App;
